import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

import type { SalesDivision } from "@shared/types/ProductLine";

const allowedSources = ["product_card", "sku_item"];

interface ProductCardSalesDivisionsParams {
  source: string;
  salesDivisions: SalesDivision[];
}
export class ProductCardSalesDivisionsEntity extends BaseEntityClass {
  sales_divisions: SalesDivision[];

  constructor(params: ProductCardSalesDivisionsParams) {
    if (!allowedSources.includes(params.source)) {
      throw new Error(`Invalid sales_division entity source: ${params.source}`);
    }

    super();
    this.type = `${params.source}_sales_divisions`;
    this.entity_version = 2;
    this.sales_divisions = params.salesDivisions;
  }

  static forProductCard(salesDivisions: SalesDivision[]): ProductCardSalesDivisionsEntity {
    if (salesDivisions?.length) {
      return new ProductCardSalesDivisionsEntity({
        source: "product_card",
        salesDivisions,
      });
    }
  }

  static forSkuItem(salesDivisions: SalesDivision[]): ProductCardSalesDivisionsEntity {
    if (salesDivisions?.length) {
      return new ProductCardSalesDivisionsEntity({
        source: "sku_item",
        salesDivisions,
      });
    }
  }
}
